import {type List} from 'immutable';

import {type ConversationMessage} from './types';

export const checkIfNewMessageExists = (prevMsgs: List<ConversationMessage>, newMsgs: List<ConversationMessage>) => {
    if (!newMsgs) {
        return true;
    }
    if ((!prevMsgs || prevMsgs.size === 0) && newMsgs.size > 0) {
        return true;
    }
    if (!prevMsgs && newMsgs.size === 0) {
        return false;
    }
    return prevMsgs.size > 0 && newMsgs.size > 0 && prevMsgs.last()?.messageId !== newMsgs.last()?.messageId;
};

// Matches strings containing login ids, e.g. "Famly.Login:Login|d4d3e870-2188-4b57-ad9d-dd84263cd6ec|Private"
const loginIdRegex = /Famly\.Login:Login\|([a-z0-9-]+)+\|/;

export const extractLoginIdFromParticipant = (participant: {recipient: string}): string | undefined => {
    return loginIdRegex.exec(participant?.recipient)?.[1];
};

export const MESSAGES_PER_PAGE = 20;
